import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

// Hooks
import { useToggle } from 'Shared/utils/hooks';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';
import { useBaProfile } from 'Shared/utils/hooks/use-ba-profile';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';
import WpAvatar from 'Wpds/components/avatar/WpAvatar';
import EditUserAvatarModal from 'Shared/components/EditUserAvatarModal/EditUserAvatarModal';

import './WorkspacePersonalAvatar.scss';

function WorkspacePersonalAvatar() {
  const { featureFlagShowBaInfoInUserProfile: ffShowBaInfo } = useFlags();

  const [isModalOpen, toggleIsModalOpen] = useToggle(false);
  const { user } = useCurrentUser();

  const { referencePatternName } = useBaProfile({ user, withFetch: false });

  const baseClassName = 'WorkspacePersonalAvatar';

  const AvatarMarkup = () => {
    if (user.avatar.profilePictureUrl) {
      return (
        <WpAvatar
          size="xl"
          avatar={user.avatar}
          referencePattern={ffShowBaInfo && referencePatternName}
          showReferencePatternIcon={ffShowBaInfo}
        />
      );
    } else {
      return (
        <div className={`${baseClassName}__empty`}>
          <WpIcon name="plus" size="sm" />
          <span>photo</span>
        </div>
      );
    }
  };

  return (
    <>
      <div className={baseClassName} onClick={toggleIsModalOpen}>
        <AvatarMarkup />
      </div>
      {isModalOpen && <EditUserAvatarModal user={user} isOpen={isModalOpen} toggleIsOpen={toggleIsModalOpen} />}
    </>
  );
}

export default WorkspacePersonalAvatar;
